// eslint-disable-next-line import/prefer-default-export
export const SERVICES = [
  {
    id: 'dark-web-monitoring',
    title: 'Dark Web Monitoring',
    icon: 'fas fa-user-secret',
    message: 'Monitor personal information on the dark web to protect your identity',
  },
  {
    id: 'financial-account-monitoring',
    title: 'Financial Account Monitoring',
    icon: 'fas fa-landmark',
    message: 'Monitor changes to account settings and attempts to add any new account holders',
  },
  {
    id: 'non-credit-loan-monitoring',
    title: 'Non-Credit Loan Monitoring',
    icon: 'fas fa-money-check-alt',
    message: 'Monitor attempts to use your personal information to open unauthorized payday loans',
  },
  {
    id: 'change-address-monitoring',
    title: 'Change of Address Monitoring',
    icon: 'fas fa-home',
    message: 'Monitor unauthorized address changes at the United States Postal Service',
  },
  {
    id: 'ssn-trace',
    title: 'SSN Trace',
    icon: 'fas fa-user-shield',
    message:
      'Use social security number tracing to track every address your social security number is linked to',
  },
  {
    id: 'credit-score',
    title: 'Credit Score',
    icon: 'fas fa-credit-card',
    message: 'Monitor changes to account settings and attempts to add any new account holders',
  },
];
